import React from "react";
import checked from "./../../../Images/checked.png";

const OctopusHairCutWhy = () => {
  return (
    <div className="faceWhyContainer">
      <h5>Why Choose the Octopus Haircut?</h5>
      <ul>
        <li>
          <span>
            <img src={checked} alt="" />
            Add Volume and Texture{" "}
          </span>
          <p>
            If you're struggling with flat or lifeless hair, the{" "}
            <a href="https://scentlifestyle.com/octopus-haircut-for-women-in-bangalore">
              Octopus Haircut for Women in Bangalore{" "}
            </a>
            is the perfect solution. The layered design adds volume and
            dimension, making your hair appear fuller and more dynamic. This
            haircut works exceptionally well for those with fine hair, as the
            layers create the illusion of thickness.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Easy to Maintain{" "}
          </span>
          <p>
            Another benefit of the{" "}
            <a href="https://scentlifestyle.com">Octopus Haircut</a> is its
            low-maintenance nature. The layers are designed to blend seamlessly,
            allowing you to style your hair effortlessly. Whether you prefer to
            air-dry your hair for a natural look or use styling tools for a more
            polished finish, this haircut adapts to your routine, saving you
            time in your busy schedule.
          </p>
        </li>
        <li>
          <span>
            <img src={checked} alt="" />
            Perfect for Any Occasion{" "}
          </span>
          <p>
            From casual outings to formal events, the{" "}
            <a href="https://scentlifestyle.com/octopus-haircut-for-women-in-bangalore">
              Octopus Haircut for Women in Bangalore
            </a>{" "}
            suits every occasion. You can easily dress it up or down, making it
            a practical choice for women who want a hairstyle that transitions
            well between different settings.
          </p>
        </li>
      </ul>
    </div>
  );
};

export default OctopusHairCutWhy;
